import Vue from 'vue';

/**
 * 性能优化
 * 仅加载首页需要使用的api ps 消息进入
 * @param item
 * @returns {*}
 */
export const checkResultDataHandle = (item) => {
  return Vue.prototype.COMMON.getObjByKeys(['code', 'msg', 'canCreateExpense', 'isOk', 'resultCode'], item);
};
export const getReceiptList = (errorList, tipList = []) => {
  return errorList.concat(tipList).map((label) => {
    return {
      ...label,
      name: label.title,
      toast: label.message,
      type: label.code,
    };
  });
};
export const invoiceDetailDataHandle = (res) => {
  // 多发票列表进入 数据已处理
  if (!res.data) {
    return [res];
  }
  return res.data.map((item) => {
    return {
      ...item.invoiceInfo,
      receiptLabels: getReceiptList(item.errorListV2 || [], item.tipList || []),
      ...checkResultDataHandle(item),
    };
  });
};

/**
 * 发票是否查验成功
 * @param digitalInvoice
 * @returns {boolean}
 */
export const isCheckSuccessfulInvoice = (digitalInvoice) => {
  return digitalInvoice.checkResult === 'R_0000';
};

/**
 * 信息是否完整
 * @returns {boolean}
 */
export const isCompleteInvoice = (resultCode) => {
  // 不完整code
  const resultCodes = ['R_2002', 'R_2007', 'R_2008', 'R_2009', 'R_2012', 'R_2013', 'R_2027'];
  return !resultCodes.includes(resultCode);
};

export const isEditableInvoice = (invoice) => {
  // 特殊校验码可编辑
  if (invoice.resultCode === '130102') {
    return true;
  }
  // 不能生成费用
  if (invoice.isOk === 'N') {
    // 查验失败可编辑
    if (!isCheckSuccessfulInvoice(invoice)) {
      return true;
    } else {
      return !isCompleteInvoice(invoice.resultCode);
    }
  }
  // 或者查验失败即可编辑
  return !isCheckSuccessfulInvoice(invoice);
};

/**
 * 发票详情路由对象
 * @param source 来源
 * @param invoiceType 类型
 * @param formOID 表单id
 * @param applicationOID 申请人id
 * @returns {
 *     {
 *          name: string,
 *          params: {
 *              pageSource: *,
 *              invoiceType: *
 *          },
 *          query: {
 *              formOID: *,
 *              applicationOID: *
 *          }
 *     }
 * }
 */
export const detailRouterOption = ({
  source,
  invoiceType = 'scan',
  formOID,
  applicationOID,
  isCorpBusiness,
  ownerId,
  pageFrom,
}) => {
  return {
    name: 'expense-invoice-detail',
    params: {
      pageSource: source,
      invoiceType: invoiceType,
    },
    query: {
      // 用于获取发票对应推荐费用类型
      formOID: formOID,
      applicationOID: applicationOID,
      isCorpBusiness,
      ownerId,
      pageFrom,
    },
  };
};

/**
 * 需要提示查验返回信息
 * @param invoice 发票详情
 * @returns {boolean}
 */
export const isAutoCalculateInvoice = (invoice) => {
  return ['R_2010', 'R_2012', 'R_2013'].includes(invoice.resultCode);
};
